import { Pause, Volume2, VolumeX, Heart as HeartIcon, Sandwich, Timer, Flag, Swords, Star } from "lucide-react";
import { WEAPONS, MAIN_LEVELS, MAX_LEVEL } from "@/game/config";
import { POWER_INFO } from "@/game/engine";

const Heart = ({ fill }) => (
  <span className={`hud-heart ${fill === 2 ? "full" : fill === 1 ? "half" : "empty"}`} />
);

export const HUD = ({ hud, onPause, muted, onMute }) => {
  const hearts = Array.from({ length: hud.maxHp / 2 }, (_, i) => Math.max(0, Math.min(2, hud.hp - i * 2)));
  const pct = Math.min(100, (hud.toast / hud.goal) * 100);
  return (
    <div className="hud" data-testid="hud-container">
      <div className="hud-group">
        <div className="hud-hearts" data-testid="hud-hearts-display" data-hp={hud.hp}>
          {hearts.map((f, i) => <Heart key={i} fill={f} />)}
        </div>
        <div className="hud-chip" data-testid="hud-lives-display"><HeartIcon size={14} className="chip-ic" />LIVES x{hud.lives}</div>
      </div>
      <div className="hud-group hud-toast">
        <div className="hud-chip" data-testid="hud-toast-counter"><Sandwich size={14} className="chip-ic" />TOAST {hud.toast}/{hud.goal}</div>
        <div className="toast-bar"><div style={{ width: `${pct}%` }} /></div>
      </div>
      <div className="hud-group">
        {hud.timeLeft !== undefined && (
          <div className={`hud-chip timer ${hud.timeLeft <= 30 ? "low" : ""}`} data-testid="hud-timer">
            <Timer size={14} className="chip-ic" />{Math.floor(hud.timeLeft / 60)}:{String(hud.timeLeft % 60).padStart(2, "0")}
          </div>
        )}
        <div className="hud-chip" data-testid="hud-level-display"><Flag size={14} className="chip-ic" />LV {hud.level}/{hud.level > MAIN_LEVELS ? MAX_LEVEL : MAIN_LEVELS}</div>
        <div className="hud-chip weapon hide-sm" data-testid="hud-weapon-display"><Swords size={14} className="chip-ic" />{WEAPONS[hud.weapon].name}</div>
        <div className="hud-chip score" data-testid="hud-score-display"><Star size={14} className="chip-ic" />{hud.score.toLocaleString()}</div>
        <button className="hud-icon" onClick={onMute} data-testid="hud-mute-button" aria-label="mute">
          {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
        </button>
        <button className="hud-icon" onClick={onPause} data-testid="hud-pause-button" aria-label="pause">
          <Pause size={16} />
        </button>
      </div>
    </div>
  );
};

export const HudOverlay = ({ hud }) => (
  <div className="hud-overlay">
    {hud.boss !== null && (
      <div className="boss-bar" data-testid="hud-boss-bar">
        <span>{hud.bossName?.toUpperCase()}</span>
        <div><div style={{ width: `${hud.boss}%` }} /></div>
      </div>
    )}
    <div className="hud-powers" data-testid="hud-powers">
      {hud.exitOpen && <span className="power-chip exit" data-testid="hud-exit-open">EXIT OPEN</span>}
      {hud.powers.map((p) => {
        const [k, s] = p.split(":");
        return (
          <span key={k} className="power-chip" style={{ color: POWER_INFO[k].color, borderColor: POWER_INFO[k].color }} data-testid={`hud-power-${k}`}>
            {POWER_INFO[k].label}{s ? ` ${s}s` : ""}
          </span>
        );
      })}
    </div>
  </div>
);
